document.addEventListener('DOMContentLoaded', function () {
  
  function initLogoSlider() {
    var containers = document.querySelectorAll('.logo-list__container');

    containers.forEach(function (container) {
      var grid = container.querySelector('.logo-list__grid--carousel-mobile');
      if (!grid) return;

      var enableCarousel = container.getAttribute('data-enable-carousel') === 'true';
      var enableAutoplay = container.getAttribute('data-enable-autoplay') === 'true';
      var autoplaySpeed = parseInt(container.getAttribute('data-autoplay-speed'), 10) || 4000;

      var autoplayInterval = null;
      var isPaused = false;

      // Autoplay slider logic
      function startAutoplay() {
        if (!enableCarousel || !enableAutoplay || window.innerWidth >= 750) return;
        
        stopAutoplay();

        autoplayInterval = setInterval(function () {
          if (isPaused) return;

          var items = grid.querySelectorAll('.logo-list__item');
          if (items.length <= 1) return;

          var itemWidth = items[0].offsetWidth;
          var maxScrollLeft = grid.scrollWidth - grid.clientWidth;

          // If we are at the end, wrap back to start
          if (grid.scrollLeft >= maxScrollLeft - 10) {
            grid.scrollTo({
              left: 0,
              behavior: 'smooth'
            });
          } else {
            grid.scrollBy({
              left: itemWidth,
              behavior: 'smooth'
            });
          }
        }, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      // Pause autoplay on user touch interactions
      grid.addEventListener('touchstart', function () {
        isPaused = true;
        stopAutoplay();
      }, { passive: true });

      grid.addEventListener('touchend', function () {
        // Resume autoplay after 3 seconds of inactivity
        setTimeout(function () {
          isPaused = false;
          startAutoplay();
        }, 3000);
      });

      // Manage auto-sliding based on viewport resize (start only on mobile)
      window.addEventListener('resize', function () {
        if (window.innerWidth >= 750) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      // Start initially
      startAutoplay();
    });
  }

  // Initialize
  initLogoSlider();

  // Re-initialize slider if Shopify customizer updates sections
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.logo-list-section')) {
      initLogoSlider();
    }
  });

});
